import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'

import 'element-ui/lib/theme-chalk/index.css'

// 导入 axios
import axios from 'axios' 
Vue.prototype.$http = axios 
import axios2 from 'axios' 
Vue.prototype.$http2 = axios2 
// 全局配置 axios 请求的根路径, 可以不写.
axios.defaults.baseURL = 'https://qtapi.pgacg.com/jiuzhou/gm/server'
// axios.defaults.baseURL = 'http://172.18.82.16:20018/changbai/gm/server/'
// 把 axios 挂载到 Vue 原型上. 今后,在每个 .vue 组件中发起请求,直接调用 this.$http 即可.
// axios2.defaults.baseURL = 'https://yspay.pgacg.com/api'
// 配置请求超时时间
axios.defaults.timeout = 5000 // 单位是毫秒


Vue.use(ElementUI, { locale })

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
